// Shared display helpers for the user reports admin screens.

// Fired with `detail: { count }` when a fresh pending count is known, or with no
// count when an action changed it and the sidebar should re-fetch.
export const PENDING_REPORTS_COUNT_EVENT = 'reports-pending-count';

export function emitPendingReportsCount(count) {
  window.dispatchEvent(new CustomEvent(PENDING_REPORTS_COUNT_EVENT, { detail: { count } }));
}

export const REPORT_TABS = [
  { value: 'pending', label: 'Pending' },
  { value: 'reviewed', label: 'Reviewed' },
  { value: 'all', label: 'All' },
];

export const REPORT_SORTS = [
  { value: 'most_reported', label: 'Most reported' },
  { value: 'latest', label: 'Latest' },
];

// Deleted wins over the others: a deleted account is usually also inactive.
export function getAccountStatus(user) {
  if (user?.isDeleted) return { label: 'Deleted', className: 'gc-pending' };
  if (user?.isBlocked === 1) return { label: 'Blocked', className: 'blocked' };
  if (user?.isActive === 0) return { label: 'Inactive', className: 'gc-pending' };
  return { label: 'Active', className: 'active' };
}

export function getReportStatus(status) {
  if (status === 'pending') return { label: 'Pending', className: 'needs-review' };
  return { label: 'Reviewed', className: 'gc-pending' };
}

export function pluralize(count, word) {
  return `${count} ${word}${count === 1 ? '' : 's'}`;
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
}

export function getBlockCopy(name) {
  return {
    title: 'Block user?',
    message: `Block ${name || 'this user'} from the platform? They'll be logged out on every device and hidden from all users. You can unblock them from the Users page.`,
    confirm: 'Block user',
  };
}

export function getDismissCopy(name) {
  return {
    title: 'Dismiss reports?',
    message: `Dismiss these reports? No action will be taken against ${name || 'this user'}. The people who reported them still won't see them.`,
    confirm: 'Dismiss',
  };
}
